import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withLocalize } from 'react-localize-redux';
import Image from '../../../common/image';
import { Project } from '../../../common/constant';
import { getRandColor } from '../../../common/tagColorPreset';
import { Address, TagsContainer, StyledLabel } from './featuredTile';

const EventListTileBase = (props) => {
  const { event, translate } = props;
  const {
    slug, name, coverImageUrl, tags
  } = event;

  const clickEvent = (e) => {
    e.preventDefault();
    props.history.push(`/event/${slug}`);
  };

  const renderLocation = () => {
    const { event } = props;
    const { isOnline, location } = event;

    let address = '';
    if (location) {
      address = get(JSON.parse(location), 'value.address');
    }
    if (isOnline === 'hybrid') {
      return <Address>{translate('eventInfo.hybridHackathon')}</Address>;
    }
    if ((isOnline === 'offline' || isOnline === 'online') && address && address.formattedAddress) {
      return <Address>{translate('eventInfo.inPersonHackathon')}</Address>;
    }
    return <Address>{translate('eventInfo.onlineHackathon')}</Address>;
  };

  return (
    <Card onClick={clickEvent}>
      <Image alt={name} src={coverImageUrl || Project.defaultCoverImage} />
      <CardContent>
        {
          renderLocation()
        }
        <EventName>
          {name}
        </EventName>
        {/* <CreatorName>{translate('common.organizer')}: {creatorName}</CreatorName> */}
        <TagsContainer>
          {
            tags && (
              tags.map((tag, index) => {
                const randColorObj = getRandColor();
                return (
                  <StyledLabel
                    key={`${index}-${tag}`} category='category'
                    isRound
                    bg={randColorObj.bg}
                    color={randColorObj.color}
                  >{tag}
                  </StyledLabel>
                );
              }))
          }
        </TagsContainer>
      </CardContent>
    </Card>
  );
};

export const EventListTile = compose(withLocalize, withRouter)(EventListTileBase);


export const GroupListTile = () => (
  <GroupCard>
    <Image src='/img/event/event-bg2.jpg' />
    <CardContent>
      <h5 className='name'>
        Long long long group name here
      </h5>
      <p className='description groupDescription'>
        This  A game jam is an event where game enthusiasts come together as a community and create a game in...
      </p>
      <span className='attendees'>222 attendees</span>
    </CardContent>
  </GroupCard>
);

const Card = styled.div`
  width: 100%;
  min-height: 176px;
  border: 1px solid #EAECF0;
  z-index: 1000;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  border-radius: 12px;
  display: flex;
  justify-content:center;
  align-items:center;
  transition: all 0.1s linear;
  cursor: pointer;
  margin: 1em 0;
  padding: 1em;

  @media only screen and (max-width: 768px) { 
    flex-direction: column;
    align-items:flex-start;
    height: auto;
    width: 90%;
    margin: 1em auto;
    padding: 1em;
  }
  @media only screen and (max-width: 375px) { 
    width:100%;
  }

  && {
    .dimmable {
      width: 200px;
      height: 144px;
      border-radius: 8px;
    }

    img.ui.image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      object-fit: cover;
    }

    @media only screen and (max-width: 768px) { 
      .dimmable {
        margin: 0 0 1em 2em;
        transform: translateY(0);
      }
    }
  } 

    :hover {
      transform: translateY(-5px);
    }
`;

const GroupCard = styled(Card)`
  && {
  .dimmable {
    width: 56px;
    height: 56px;
    border-radius: 13px;
    transform: translateY(-2em);
  }
  img.ui.image {
    width: 100%;
    height: 100%;
    border-radius: 13px;
    object-fit: cover;
  }

  @media only screen and (max-width: 768px) { 
    .dimmable {
      margin: 0 0 1em 2em;
      transform: translateY(0);
    }
  }
} 
`;

const CardContent = styled.div`
  width: 70%;
  padding: 0 2em;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 600;

  @media only screen and (max-width: 768px) { 
    width: 100%;
  }
  .date {
    font-family: 'Inter';
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #6A7380;
  }

  .description {
    font-family: 'Lato';
    font-size: 16px;
    line-height: 19px;
    color: #384455;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    text-overflow: ellipsis; 
  }
  .groupDescription {
    color: #676767;
  }
  .attendees {
    font-family: 'Lato';
    font-size: 16px;
    line-height: 19px;
    color: #99B2C6;
  }
`;

const EventName = styled.h5`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
  margin: 0.2em 0;
`;

// const CreatorName = styled.span`
//   font-family: 'Inter';
//   font-style: normal;
//   font-weight: 400;
//   font-size: 16px;
//   line-height: 24px;
//   color: #667085;
//   margin: 0.2em 0 0.4em 0;
// `;



// WEBPACK FOOTER //
// ./src/components/events/components/tile/listTile.js